import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { Container, Button, Box, Grow } from '@mui/material';
import { SpeedDial, SpeedDialAction } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import Inventory from './components/Inventory';
import UploadForm from './components/UploadForm';
import Login from './components/Login';
import CustomSpeedDial from './components/CustomSpeedDial';

function App() {
  const [openUploadForm, setOpenUploadForm] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false); // Track if the user is logged in

  // Check if the token exists in localStorage to determine if the user is logged in
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setIsAuthenticated(true);
    }
  }, []);

  // Function to handle login success
  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  // Function to handle the modal open state for the upload form
  const handleOpen = () => {
    setOpenUploadForm(true);
  };

  const handleClose = () => {
    setOpenUploadForm(false);
  };

  // Function to handle logout
  const handleLogout = () => {
    localStorage.removeItem('token'); // Remove the token from localStorage
    setIsAuthenticated(false);
    window.location.reload(); // Reload the page to reset the app state
  };

  return (
    <Router>
      <Routes>
        {/* Route for the admin login page */}
        <Route
          path="/admin"
          element={
            <Box sx={{ backgroundColor: 'black', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Grow in={true} timeout={800}>
                <Box sx={{ backgroundColor: 'rgba(38,38,38,1)', padding: '20px', borderRadius: '8px', boxShadow: 3, width: '300px', textAlign: 'center' }}>
                  <Login onLogin={handleLogin} />
                </Box>
              </Grow>
            </Box>
          }
        />

        {/* Route for the main inventory and logo */}
        <Route
          path="/"
          element={
            <PublicApp
              openUploadForm={openUploadForm}
              handleOpen={handleOpen}
              handleClose={handleClose}
              isAuthenticated={isAuthenticated}
              handleLogout={handleLogout}
            />
          }
        />

        {/* Fallback route to redirect unauthenticated users */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

function PublicApp({ openUploadForm, handleOpen, handleClose, isAuthenticated, handleLogout }) {
  return (
    <Container>
      {/* Only show the Add Item button and UploadForm if the user is authenticated */}
      {isAuthenticated && (
        <>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleOpen} 
            sx={{
              backgroundColor: 'rgba(244,205,24,1)',
              color: 'black',
              fontWeight: 'bold',
              fontFamily: 'Montserrat, Arial, sans-serif',
              position: 'fixed',
              left: '16px',
              top: '0px',
              zIndex: 1000
            }}
          >
            Add Item
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleLogout}
            sx={{
              backgroundColor: 'rgba(244,205,24,1)',
              color: 'black',
              fontWeight: 'bold',
              fontFamily: 'Montserrat, Arial, sans-serif',
              position: 'fixed',
              right: '16px',
              top: '0px',
              zIndex: 1000
            }}
          >
            Logout
          </Button>
          {/* Upload Form Modal */}
          <UploadForm open={openUploadForm} handleClose={handleClose} />
        </>
      )}
      {/* Always visible logo and inventory */}
      <center>
        <a href='https://firehemp.com/thca-wholesale/'>
        <img
          src="FireHemp.png"
          style={{ width: '40%', height: '40%' }}
          alt="Logo"
        /></a>
      </center>
      <Inventory />

      <CustomSpeedDial/>
    </Container>
  );
}

export default App;
